module.exports = "/_next/static/images/Hero-c379004d2f5b6b749da25d2509592f59.webp";